import { render, staticRenderFns } from "./SearchModulesAndTopics.vue?vue&type=template&id=4606a5d9&"
import script from "./SearchModulesAndTopics.vue?vue&type=script&lang=js&"
export * from "./SearchModulesAndTopics.vue?vue&type=script&lang=js&"
import style0 from "./SearchModulesAndTopics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports